import { Customer } from '@probatix/common/services/RTKServices/patients/index.model'
import { returnDateOfBirth } from '@probatix/common/services/services.helpers'
import { Nullable } from '@probatix/common/models/global'

export const isBillingAddressSet = <T extends Customer>(data: Nullable<T>): boolean => {
  if (!data) {
    return false
  }

  const { billingAddressCity, billingAddressCountry, billingAddressStreet, billingAddressZipCode } = data

  return !!(billingAddressCity && billingAddressCountry && billingAddressStreet && billingAddressZipCode)
}

export const getBillingAddress = (main: Customer) => {
  const isBillingSet = isBillingAddressSet(main)

  return {
    billingAddressCity: isBillingSet ? main.billingAddressCity : main.addressCity,
    billingAddressCountry: isBillingSet ? main.billingAddressCountry : main.addressCountry,
    billingAddressStreet: isBillingSet ? main.billingAddressStreet : main.addressStreetAndHouseNumber,
    billingAddressZipCode: isBillingSet ? main.billingAddressZipCode : main.addressZipCode,
    ...(isBillingSet && { company: main.company }),
  }
}

export const transformCustomerToOrderPayload = (main: Customer, includeBilling: boolean = false): Customer => {
  const payload: Customer = {
    addressCity: main.addressCity,
    addressCountry: main.addressCountry,
    addressStreetAndHouseNumber: main.addressStreetAndHouseNumber,
    addressZipCode: main.addressZipCode,
    dateOfBirth: main?.dateOfBirth && returnDateOfBirth({
      dateOfBirth: main.dateOfBirth,
      formatDate: 'yyyy-MM-dd',
    }),
    email: main.email,
    firstName: main.firstName,
    gender: main.gender,
    healthInsuranceCompanyNumber: main.healthInsuranceCompanyNumber,
    healthInsurancePolicyNumber: main.healthInsurancePolicyNumber,
    lastName: main.lastName,
    personalIdNumber: main.personalIdNumber,
    phoneNumber: main.phoneNumber,
  }

  if (includeBilling) {
    const billing = getBillingAddress(main)

    return {
      ...payload,
      ...billing,
    }
  }

  return payload
}

